import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiAddMrd = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdListDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceURL, payload);
};
